export default __webpack_public_path__ + "static/media/img-audio-video-success.81c444f3.svg";